// @flow

import { selectPricingInfos } from '@gandi/billing';
import { useResourceFetch } from '@gandi/resource/react';

import { useAppSelector } from 'src/hooks';
import {
  productsResource,
  type ProductsResourceType,
  type ProductSummary,
} from 'src/modules/mailbox-standalone/resources/products';

import type { PreFetchArgs, PreFetchReturn } from 'src/types';

export function useProductsFetch(): {
  isFailure: boolean,
  isFetching: boolean,
  isForbidden: boolean,
  isLoaded: boolean,
  label: string,
  meta: ?ProductsResourceType['fetchMeta'],
  shouldFetch: boolean,
  summaries: ?Array<ProductSummary>,
} {
  // $FlowFixMe[incompatible-call]
  const { currency, grid } = useAppSelector(selectPricingInfos);

  return useResourceFetch(productsResource, {
    currency,
    grid,
    sellable: true,
  });
}

export function preFetch({
  dispatch,
  getState,
}: PreFetchArgs<>): PreFetchReturn<> {
  const { currency, grid } = selectPricingInfos(getState());

  const url = productsResource.options.fetchPath;
  const label = productsResource.computeLabel(url, {
    currency,
    grid,
    sellable: true,
  });

  return dispatch(productsResource.fetch(url, { label }));
}
